"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CardReentrySubmit = void 0;
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var react_stripe_elements_1 = require("react-stripe-elements");
var App_1 = require("../../App");
var LayoutContext_1 = require("../../Common/LayoutContext");
var enums_1 = require("../../Common/utils/enums");
var useTracking_1 = __importDefault(require("../../Common/utils/useTracking"));
var CardExpiration_1 = __importDefault(require("../CardFields/CardExpiration"));
var CardFieldsStyles_1 = require("../CardFields/CardFieldsStyles");
var CardNumber_1 = __importDefault(require("../CardFields/CardNumber"));
var VerifyCardError_1 = __importDefault(require("../VerifyCardError"));
var VerifyPaymentCardContext_1 = __importDefault(require("../VerifyPaymentCardContext"));
var VerifyPaymentCardStrings_1 = __importDefault(require("../VerifyPaymentCardStrings"));
exports.CardReentrySubmit = function (_a) {
    var cardReentry = _a.cardReentry, stripe = _a.stripe, submitRes = _a.submitRes;
    var _b = React.useContext(App_1.RiskContext), dispatch = _b.dispatch, state = _b.state;
    var _c = React.useContext(LayoutContext_1.LayoutContext), primaryAction = _c.primaryAction, setPrimaryAction = _c.setPrimaryAction;
    var _d = React.useContext(VerifyPaymentCardContext_1["default"]), paymentCard = _d.paymentCard, orderCart = _d.orderCart;
    var _e = useTracking_1["default"](), trackClick = _e.trackClick, trackSuccess = _e.trackSuccess, trackFailure = _e.trackFailure;
    var _f = __read(React.useState(''), 2), cardNumberError = _f[0], setCardNumberError = _f[1];
    var _g = __read(React.useState(''), 2), cardExpError = _g[0], setCardExpError = _g[1];
    var last4 = (paymentCard && paymentCard.last4) || '0000';
    var defaultError = VerifyPaymentCardStrings_1["default"].cardReentryError();
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, token, error, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(primaryAction.isSubmitting && stripe)) return [3 /*break*/, 7];
                    trackClick(orderCart.id);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, stripe.createToken()];
                case 2:
                    _a = _b.sent(), token = _a.token, error = _a.error;
                    if (!token) return [3 /*break*/, 5];
                    return [4 /*yield*/, cardReentry(paymentCard.id, token.id)];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, dispatch({ type: enums_1.RiskActions.Reset })];
                case 4:
                    _b.sent();
                    trackSuccess(orderCart.id);
                    if (state.onSuccess) {
                        state.onSuccess();
                    }
                    _b.label = 5;
                case 5:
                    if (error) {
                        trackFailure({
                            orderCartId: orderCart.id,
                            reason: 'stripe_failure',
                            message: error.message || ''
                        });
                        setPrimaryAction({ isSubmitting: false });
                    }
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _b.sent();
                    trackFailure({
                        orderCartId: orderCart.id,
                        reason: 'unknown_error',
                        message: error_1.message || ''
                    });
                    setPrimaryAction({ isSubmitting: false });
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        onSubmit();
    }, [primaryAction.isSubmitting]);
    var handleChange = function (empty, errorMessage, setError) {
        if (empty) {
            setError('Required');
        }
        if (errorMessage) {
            setError(errorMessage);
        }
        return null;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(design_language_1.Stack, { size: design_language_1.Stack.Sizes.XLarge },
            React.createElement(design_language_1.StackChildren, { size: design_language_1.StackChildren.Sizes.XLarge },
                React.createElement(CardNumber_1["default"], { error: cardNumberError, onChange: function (isEmpty, errorMessage) {
                        return handleChange(isEmpty, errorMessage, setCardNumberError);
                    }, placeholder: "XXXX XXXX XXXX " + last4 }),
                React.createElement(CardExpiration_1["default"], { error: cardExpError, onChange: function (isEmpty, errorMessage) {
                        return handleChange(isEmpty, errorMessage, setCardExpError);
                    } }))),
        submitRes && submitRes.error && (React.createElement(CardFieldsStyles_1.AddCardError, null,
            React.createElement(VerifyCardError_1["default"], { defaultError: defaultError })))));
};
exports["default"] = react_stripe_elements_1.injectStripe(exports.CardReentrySubmit);
